import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../../config';

const baseUrl = config.baseUrl;
const orgEndpointInsert = '/api/inserVisitaTecnicaSostenibilidad';
const orgEndpointVisitasTecnicas = '/api/visitasTecnicasSostenibilidad/';
const orgEndpointAlmacenarSoportesVisitaTecnica = '/api/almacenarSoportesVisitaTecnicaSostenibilidad/';

const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
//Servicio para registrar  visitas tecnicas de sostenibilidad desde el backend
export const insertVisitaTecnicasostenibilidad = async (data) => {
    try {
        const response = await axios.post(`${baseUrl}${orgEndpointInsert}`, data, {
            headers: {
                'Content-Type': 'application/json',  // Encabezado JSON para enviar datos correctamente
            },
        });
        return response.data;
    } catch (error) {
        console.error('Error al crear la encuesta:', error);
        throw error;
    }
};



//Servicio para obtener todas las visitas tecnicas de sostenibilidad desde el backend
export const getVisitasTecnicasSostenibilidad = async () => {
    try {
        const response = await api.get(`${baseUrl}${orgEndpointVisitasTecnicas}`);
        return {
            status: response.status,
            data: response.data.visitas_tecnicas,
        };
    } catch (error) {
        console.error('Error fetching visitas técnicas de sostenibilidad:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error fetching visitas técnicas de sostenibilidad'
        };
    }
};

//Servicio para obtener la  visitas tecnicas de sostenibilidad por id desde el backend
export const getVisitaTecnicaSostenibilidadById = async (id) => {
    try {
        const response = await api.get(`${baseUrl}${orgEndpointVisitasTecnicas}${id}`);
        return {
            status: response.status,
            data: response.data.data,

        };
    } catch (error) {
        console.error('Error fetching visita técnica de sostenibilidad:', error);
        return {
            status: error.response ? error.response.status : 500,
            message: 'Error fetching visita técnica de sostenibilidad'
        };
    }
};



// Función para almacenar soportes de visitatecnica de sostenibilidad
export const AlmacenarSoportesVisitaTecnicasostenibilidad = async (formData) => {
    try {
      // Usar la instancia api en lugar de axios.post directamente
      const response = await api.post(orgEndpointAlmacenarSoportesVisitaTecnica, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      return response.data;
    } catch (error) {
      console.error('Error al subir archivos:', error.response?.data || error.message);
      throw error;
    }
  };


  // Función para actualizar visita tecnica sostenibilidad
  export const updateVisitaTecnicaSostenibilidad = async (id, data) => {
    try {
      const response = await axios.put(`${baseUrl}${orgEndpointVisitasTecnicas}`, {id:id, detalle: data}, {
        headers: {
            'Content-Type': 'application/json',  // Encabezado JSON para enviar datos correctamente
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al actualizar la visita Tecnica sostenibilidad:', error);
      throw error;
    }
  };
  
export default insertVisitaTecnicasostenibilidad;